import { Effarig } from "./effarig";
import { Enslaved } from "./enslaved";
import { Laitela } from "./laitela/laitela";
import { Pelle } from "./pelle/pelle";
import { Ra } from "./ra/ra";
import { Teresa } from "./teresa";
import { V } from "./V";

export const Celestials = {
  teresa: Teresa,
  effarig: Effarig,
  enslaved: Enslaved,
  v: V,
  ra: Ra,
  laitela: Laitela,
  pelle: Pelle
};

GameDatabase.celestials.descriptions = [
  {
    name: "Teresa",
    nameDat: "Терезе",
    effects() {
      return `Генерация Временны́х Теорем Глифами отключена.
      Вы получаете меньше Очков Бесконечности и Очков Вечности (x^${format(0.55, 2, 2)}).`;
    },
  },
  {
    name: "Effarig",
    nameDat: "Эффаригу",
    effects() {
      return `Все множители измерений, скорость игры и скорость тика значительно уменьшены, как в Растяжении.
      Мощность Бесконечности уменьшает сбавки на производство и скорость игры, а Осколки Времени уменьшают сбавку
      на Скорости Тика.
      Уровни Глифов временно ограничены до ${formatInt(Effarig.glyphLevelCap)}, редкость не изменена.`;
    },
    description() {
      return `Вы выйдете из Реальности Эффарига когда впервые пройдёте её Слой.`;
    }
  },
  {
    name: "The Nameless Ones",
    nameDat: "Безымянным",
    effects() {
      return `Уровень Глифов поднят до минимума в ${formatInt(5000)}.
      Покупки Измерений Бесконечности, Времени, и 8ых Измерений антиматерии ограничены до ${formatInt(1)} каждое.
      Множители Измерений Антиматерии всегда Растянуты (Эффект Глифа применяется только внутри настоящего Растяжения).
      Временно́е Исследование 192 (неограниченные Репликанты) заблокировано.
      Чёрная Дыра отключена.
      Производство Тахион Частиц и Растянутого Времени значительно заторможено.
      Генерация Временны́х Теорем в Глифах Растяжения отключена.
      Некоторые цели Челленджей повышены.
      Накопленное игровое время разряжается с пониженой эффективностью (экспонента^${format(0.55, 2, 2)}).`;
    }
  },
  {
    name: "V",
    nameDat: "Ви",
    effects() {
      const vEffect = `Все множители Измерений, заработок Очков Вечности, заработок Очков Бесконечности, \
      заработок Растянутого Времени и интервал Репликантов возведены в степень 0.5 (квадратный корень).`;
      const vEffectAdditional = `
      Эффект Экспоненциальной Алхимии Глифов отключен.`;

      return Ra.unlocks.unlockGlyphAlchemy.canBeApplied
        ? vEffect + vEffectAdditional
        : vEffect;
    }
  },
  {
    name: "Ra",
    nameDat: "Ра",
    effects() {
      return `У вас есть только ${formatInt(4)} Буста Измерений и вы не сможете получить больше.
      Покупка множителя Скорости Тика зафиксирована на ${formatX(1.1245, 0, 3)}.`;
    },
  },
  {
    name: "Lai'tela",
    nameDat: "Лай'теле",
    effects() {
      let disabledDims;
      const highestActive = 8 - Laitela.difficultyTier;
      switch (highestActive) {
        case 0:
          disabledDims = "всех Измерений";
          break;
        case 1:
          disabledDims = "2оого и выше Измерений";
          break;
        case 2:
          disabledDims = "3его и выше Измерений";
          break;
        case 7:
          disabledDims = "8ых Измерений";
          break;
        default:
          disabledDims = `${highestActive + 1}ого и выше Измерений`;
          break;
      }
      const disabledText = highestActive === 8
        ? ""
        : `Производство от ${disabledDims} отключено.`;

      return `Заработок Очков Бесконечности и Очков Вечности растянут.
      Скорость игры уменьшена до ${formatInt(1)} и постепенно возвращается на протяжении ${formatInt(10)} минут.
      Накопление, разрядка, пульсация, и инверсия Чёрной Дыры отключены.
      ${disabledText}`;
    },
    description() {
      return `Антиматерия генерирует энтропию внутри этой Реальности.\
      На ${formatPercents(1)} энтропии, Реальность становится дестабилизированной\
      и вы получаете награду, основанную на том как быстро вы достигли ${formatPercents(1)}.
      Дестабилизация Реальности менее чем за ${formatInt(30)} секунд делает её значительно сложнее,\
      давая взамен гораздо более ценную награду .\
      Сделав это ${formatInt(8)} раз вы получите бонус ${formatX(8)} к заработку Тёмной Материи.`;
    }
  },

];
